import Header from './components/header/Header';
import Navbar from './components/navbar/Navbar';
import LetsConnect from './components/letsConnect/LetsConnect';
import Footer from './components/footer/Footer';
import Home from './pages/home/Home';
import Author from './pages/author/Author';
import Books from './pages/books/Books';
import BookDetails from './pages/bookDetails/BookDetails';
import Reviews from './pages/reviews/Reviews';
import Newsletter from './pages/newsletter/Newsletter';

import { Route, Routes, Navigate } from 'react-router-dom';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header/>
      <Navbar/>
      <Routes>
        <Route index element={<Home />}/>
        <Route path ="/author" element={<Author />}/>
        <Route path ="/books" element={<Books />}/>
        <Route path ="/books/:bookName" element={<BookDetails />}/>
        <Route path ="/reviews" element={<Reviews />}/>
        <Route path ="/newsletter" element={<Newsletter />}/>
        <Route path ="*" element={<Navigate to="/" replace />}/>
      </Routes>
      <LetsConnect/>
      <Footer/>
    </div>
  );
}

export default App;
